export var BORDER_WIDTH = 2;
export var DISABLED_ICON_OFFSET = 24;
export var INSET_ELEMENT_DEFAULTS = {
  width: 20,
  inset: 12
};